/* eslint-disable react/jsx-one-expression-per-line */
import * as React from "react";
import { Link } from "react-router-dom";
import Collapsible from "react-collapsible";

// Components
import Container from "../components/Container/Container";
import Footer from "../components/Footer/Footer";
import Button from "../components/Button/Button";

const HowSecureIs: React.FC = () => {
  return (
    <>
      <Container>
        <div className="w-11/12 xxl:w-full mx-auto pb-4">
          <h1 className="text-xl md:text-38 lg:text-46 text-dw-blue font-semibold font-serif mb-2">
            How Secure Is Threat Check?
          </h1>
          <p className="font-bold text-dw-grey-13 mb-4 md:text-18">
            Digital Security is our mission and we provide you with the steps to
            keep you and your data as safe as possible. That’s why there are
            some special features you should know about this tool.
          </p>
          <div className="mb-4 text-dw-grey-13">
            <Collapsible
              trigger="Always free to use, no registration"
              triggerClassName="text-20 font-bold mb-3 cursor-pointer"
              triggerOpenedClassName="text-20 font-bold mb-3 cursor-pointer"
            >
              <p className="mt-2">
                You never have to register for Threat Check with any personal
                information like your name, email address or phone number.
                Threat Check is free to use and can be used without an account.
                Only you decide what information you would like to provide to
                Threat Check.
              </p>
            </Collapsible>
          </div>
          <div className="mb-4 text-dw-grey-13">
            <Collapsible
              trigger="Your data doesn’t leave your device while you are working on it"
              triggerClassName="text-20 font-bold mb-3 cursor-pointer"
              triggerOpenedClassName="text-20 font-bold mb-3 cursor-pointer"
            >
              <p className="mt-2">
                The information you provide is not transferred to our server
                while you are working on it. Everything you do happens locally
                in your browser until you click on{" "}
                <Link to="/save" className="font-bold underline">
                  “Save Progress”
                </Link>
                .
                <br />
                <br />
                We never store any of your results on our server. We only use
                your input to create the results.
                <br />
                <br />
                For security reasons, we recommend you update your browser to
                the latest version before using Threat Check.
              </p>
            </Collapsible>
          </div>
          <div className="mb-4 text-dw-grey-13">
            <Collapsible
              trigger="Encrypted data transmission to our server"
              triggerClassName="text-20 font-bold mb-3 cursor-pointer"
              triggerOpenedClassName="text-20 font-bold mb-3 cursor-pointer"
            >
              <p className="mt-2">
                If you have finished your work with Threat Check, your data will
                be transferred via an encrypted connection to our server. No one
                “in between” is able to read what you are transferring to the
                server.
                <br />
                <br />
                Our server only uses your data to create a personalized security
                policy and poster for you. We will never process your data for
                other reasons.
                <br />
                <br />
                Your data is never stored on our server.
              </p>
            </Collapsible>
          </div>
          <div className="mb-4 text-dw-grey-13">
            <Collapsible
              trigger="Threat Check doesn’t store your data: Please keep a backup of your
              work!"
              triggerClassName="text-20 font-bold mb-3 cursor-pointer"
              triggerOpenedClassName="text-20 font-bold mb-3 cursor-pointer"
            >
              <p className="mt-2">
                As Threat Check works on your device, be careful about closing
                tabs. Please note: All your input will be deleted if you close
                the browser tab without downloading the current version. We
                highly recommend clicking on{" "}
                <Link to="/save" className="font-bold underline">
                  “Save Progress”
                </Link>
                .
              </p>
            </Collapsible>
          </div>
          <div className="mb-4 text-dw-grey-13">
            <Collapsible
              trigger="Saving the current state of the policies"
              triggerClassName="text-20 font-bold mb-3 cursor-pointer"
              triggerOpenedClassName="text-20 font-bold mb-3 cursor-pointer"
            >
              <p className="mt-2">
                For saving the current state of the policies, we use a specific
                file ending with “.threatcheck“ that you download. This saves
                your input. If you want to continue from your last saved
                version, upload your file to the page{" "}
                <Link to="/continue" className="font-bold underline">
                  “Continue Policy“
                </Link>
                . We recommend you keep your file safe on a device that you
                trust.
              </p>
            </Collapsible>
          </div>
          <div className="mb-4 text-dw-grey-13">
            <Collapsible
              trigger="Finishing the Policies"
              triggerClassName="text-20 font-bold mb-3 cursor-pointer"
              triggerOpenedClassName="text-20 font-bold mb-3 cursor-pointer"
            >
              <p className="mt-2">
                You can’t download the policies if you haven’t completed the
                questions flagged as “Must Haves“. This is because we want to
                make sure you have secure policies that include at least the
                bare minimum security measures. If you have problems using
                Threat Check, please have a look at the FAQ{" "}
                <Link to="/faq/usage" className="font-bold underline">
                  “How Do I Use Threat Check”
                </Link>
                .
              </p>
            </Collapsible>
          </div>

          <Link to="/categories">
            <Button type="button" buttonType="secondary">
              Proceed to Policy
            </Button>
          </Link>
        </div>
      </Container>
      <Footer />
    </>
  );
};

export default HowSecureIs;
